<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- BUTTONS -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              BUTTONS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <!-- small -->
            <b-row>
              <div class="col-10">
                <h2>Small</h2>
                <p>
                  Projenin en küçük butonlarıdır. Yükseklik değeri sabit
                  <b>32px</b>'dir. Padding özelliği için değer
                  <b>0 16px</b>'dir. 'Button Group' ve 'Dropdown' ile birlikte yanyana konuşlanabilirler. Yükseklik değerlerı aynıdır.
                </p>
                <p class="bold mt-4">
                  Without Icon
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn sm bg-white text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.bg-white</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm bg-white text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.bg-white</b>.text-color-dusk
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm bg-dusk text-white">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.bg-dusk</b>.text-white
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn sm border-traid text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.border-traid</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm border-traid text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.border-traid</b>.text-color-dusk
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm bg-purple text-white">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.bg-purple</b>.text-white
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn sm border-purple text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.border-purple</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm border-dusk text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.border-dusk</b>.text-color-dusk
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm bg-tangerine text-white">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm.
                  <b>bg-tangerine</b>.text-white
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn sm bg-pale-grey text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.bg-pale-grey</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm bg-pale-grey text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.bg-pale-grey</b>.text-color-dusk
                </span>
              </div>
            </b-row>
            <b-row>
              <div class="col-10">
                <p class="bold mt-5">
                  With Icon
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn sm with-icon bg-white text-purple">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.bg-white
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm with-icon bg-white text-color-dusk">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.bg-white
                  <b>.text-color-dusk</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm with-icon bg-dusk text-white">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.bg-dusk
                  <b>.text-white</b>
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn sm with-icon border-traid text-purple">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.border-traid
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm with-icon border-traid bg-white text-color-dusk">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.border-traid
                  <b>.text-color-dusk</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm with-icon bg-purple text-white">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.bg-purple
                  <b>.text-white</b>
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn sm with-icon border-purple text-purple">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.border-purple
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm with-icon border-dusk text-color-dusk">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.border-dusk
                  <b>.text-color-dusk</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm with-icon bg-tangerine text-white">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.bg-tangerine
                  <b>.text-white</b>
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn sm with-icon bg-pale-grey text-purple">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.bg-pale-grey
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn sm with-icon bg-pale-grey text-color-dusk">
                  <i class="icon-add" />
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.sm
                  <b>.with-icon</b>.bg-pale-grey
                  <b>.text-color-dusk</b>
                </span>
              </div>
            </b-row>
            <!-- medium -->
            <b-row class="mt-5">
              <div class="col-10">
                <h2>Normal</h2>
                <p>
                  Projenin en çok kullanılan butonlarıdır. Yükseklik değeri sabit
                  <b>40px</b>'dir. İçerik yazısı dikey olarak ortalanmıştır. İkonsuz olanların padding özelliği
                  <b>0px 8px</b>, ikonlu olanların
                  <b>0px 16px 0 8px</b>'dir.
                </p>
                <p class="bold mt-4">
                  Without Icon
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn md bg-white text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.bg-white</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn md bg-white text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.bg-white</b>.text-color-dusk
                </span>
              </div>
              <div class="col-3">
                <button class="btn md bg-dusk text-white">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.bg-dusk</b>.text-white
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn md border-traid text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.border-traid</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn md border-traid text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.border-traid</b>.text-color-dusk
                </span>
              </div>
              <div class="col-3">
                <button class="btn md bg-purple text-white">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.bg-purple</b>.text-white
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn md border-purple text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.border-purple</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn md border-dusk text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.border-dusk</b>.text-color-dusk
                </span>
              </div>
              <div class="col-3">
                <button class="btn md bg-tangerine text-white">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md.
                  <b>bg-tangerine</b>.text-white
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn md bg-pale-grey text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.bg-pale-grey</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn md bg-pale-grey text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.bg-pale-grey</b>.text-color-dusk
                </span>
              </div>
            </b-row>
            <b-row>
              <div class="col-10">
                <p class="bold mt-5">
                  With Icon
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn md with-icon bg-white text-purple">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.bg-white
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn md with-icon bg-white text-color-dusk">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.bg-white
                  <b>.text-color-dusk</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn md with-icon bg-dusk text-white">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.bg-dusk
                  <b>.text-white</b>
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn md with-icon border-traid text-purple">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.border-traid
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn md with-icon border-traid bg-white text-color-dusk">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.border-traid
                  <b>.text-color-dusk</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn md with-icon bg-purple text-white">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.bg-purple
                  <b>.text-white</b>
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn md with-icon border-purple text-purple">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.border-purple
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn md with-icon border-dusk text-color-dusk">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.border-dusk
                  <b>.text-color-dusk</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn md with-icon bg-tangerine text-white">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.bg-tangerine
                  <b>.text-white</b>
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn md with-icon bg-pale-grey text-purple">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.bg-pale-grey
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn md with-icon bg-pale-grey text-color-dusk">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.md
                  <b>.with-icon</b>.bg-pale-grey
                  <b>.text-color-dusk</b>
                </span>
              </div>
            </b-row>
            <!-- big -->
            <b-row class="mt-5">
              <div class="col-10">
                <h2>Big</h2>
                <p>
                  Projenin en çok kullanılan butonlarıdır. Yükseklik değeri sabit
                  <b>48px</b>'dir. İçerik yazısı dikey olarak ortalanmıştır. İkonsuz olanların padding özelliği
                  <b>0px 8px</b>, ikonlu olanların
                  <b>0px 16px 0 8px</b>'dir.
                </p>
                <p class="bold mt-4">
                  Without Icon
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn lg bg-white text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.bg-white</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg bg-white text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.bg-white</b>.text-color-dusk
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg bg-dusk text-white">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.bg-dusk</b>.text-white
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn lg border-traid text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.border-traid</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg border-traid text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.border-traid</b>.text-color-dusk
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg bg-purple text-white">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.bg-purple</b>.text-white
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn lg border-purple text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.border-purple</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg border-dusk text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.border-dusk</b>.text-color-dusk
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg bg-tangerine text-white">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg.
                  <b>bg-tangerine</b>.text-white
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn lg bg-pale-grey text-purple">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.bg-pale-grey</b>.text-purple
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg bg-pale-grey text-color-dusk">
                  text
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.bg-pale-grey</b>.text-color-dusk
                </span>
              </div>
            </b-row>
            <b-row>
              <div class="col-10">
                <p class="bold mt-5">
                  With Icon
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn lg with-icon bg-white text-purple">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.bg-white
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg with-icon bg-white text-color-dusk">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.bg-white
                  <b>.text-color-dusk</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg with-icon bg-dusk text-white">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.bg-dusk
                  <b>.text-white</b>
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn lg with-icon border-traid text-purple">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.border-traid
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg with-icon border-traid bg-white text-color-dusk">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.border-traid
                  <b>.text-color-dusk</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg with-icon bg-purple text-white">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.bg-purple
                  <b>.text-white</b>
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn lg with-icon border-purple text-purple">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.border-purple
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg with-icon border-dusk text-color-dusk">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.border-dusk
                  <b>.text-color-dusk</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg with-icon bg-tangerine text-white">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.bg-tangerine
                  <b>.text-white</b>
                </span>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-3">
                <button class="btn lg with-icon bg-pale-grey text-purple">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.bg-pale-grey
                  <b>.text-purple</b>
                </span>
              </div>
              <div class="col-3">
                <button class="btn lg with-icon bg-pale-grey text-color-dusk">
                  <i class="icon-add" />
                  TEXT
                </button>
                <span class="xs">
                  <b>.btn</b>.lg
                  <b>.with-icon</b>.bg-pale-grey
                  <b>.text-color-dusk</b>
                </span>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>

    <!-- BUTTON GROUPS & PAGINATION -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              GROUPS &<br>PAGINATION
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <!-- small -->
            <b-row class="mt-4">
              <div class="col-3">
                <h2>Single Icon Button</h2>
                <p class="mt-4">
                  Single Icon Button' elemanlarının yüksekliği
                  <b>32px</b>'dir.
                </p>
                <div class="mt-4">
                  <button class="btn sm border-traid icon-button">
                    <i class="icon-clear" />
                  </button>
                  <button class="btn sm bg-tangerine icon-button">
                    <i class="icon-clear" />
                  </button>
                  <button class="btn sm bg-pale-grey icon-button">
                    <i class="icon-clear" />
                  </button>
                  <button class="btn sm bg-dusk icon-button">
                    <i class="icon-clear" />
                  </button>
                  <button class="btn sm bg-purple icon-button">
                    <i class="icon-clear" />
                  </button>
                </div>
              </div>
              <div class="col-3">
                <h2>Group Buttons</h2>
                <p class="mt-4">
                  Grup butonların yüksekliği
                  <b>32px</b>'dir.
                </p>
                <div class="mt-4">
                  <b-dropdown id="ddown-sm-split"
                              size="md"
                              split
                              class="border-traid"
                  >
                    <template slot="button-content">
                      <i class="icon-add" /> KAYDET
                    </template>
                    <b-dropdown-item-button>Action</b-dropdown-item-button>
                    <b-dropdown-item-button>Another action</b-dropdown-item-button>
                    <b-dropdown-item-button>Something else here...</b-dropdown-item-button>
                  </b-dropdown>
                </div>
              </div>
              <div class="col-3">
                <h2>Pagination</h2>
                <p class="mt-4">
                  Single Icon Button' elemanlarının yüksekliği
                  <b>32px</b>'dir.
                </p>
                <div class="mt-4">
                  <div class="button-select-group">
                    <button class="btn sm">
                      <i class="icon-left-arrow" />
                    </button>
                    <multiselect v-model="ButtonGroupConfig.PageNumbers.model"
                                 :allow-empty="false"
                                 :searchable="true"
                                 v-bind="ButtonGroupConfig.PageNumbers"
                    />
                    <button class="btn sm">
                      <i class="icon-right-arrow" />
                    </button>
                  </div>
                </div>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>

    <!-- BUTTON GROUPS & PAGINATION -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              DROPDOWNS
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row>
              <div class="col-10">
                <p>
                  'Small Button' ve 'Button Group'ları ile birlikte yanyana kullanılabilmesi için yükseklik değeri sabit
                  <b>32px</b>'dir.
                </p>
              </div>
            </b-row>
            <b-row class="mt-4">
              <div class="col-4">
                <multiselect v-bind="ButtonGroupConfig.SelectOnly" />
              </div>
              <div class="col-4">
                <multiselect v-bind="ButtonGroupConfig.MultipleSelect" />
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>

export default {
  name: 'Button',
  data() {
    return {
      ButtonGroupConfig: {
        SelectOnly: {
          options: ['Ankara', 'İstanbul', 'Mardin', 'Rize'],
          class: 'group',
          placeholder: 'Seçiniz',
        },
        MultipleSelect: {
          options: ['Ankara', 'İstanbul', 'Mardin', 'Rize'],
          class: 'group',
          limit: 0,
          multiple: true,
          'limit-text': (count) => `${count} öğe seçili`,
          placeholder: 'Seçiniz',
        },
        PageNumbers: {
          options: [11, 222],
          class: 'group',
          model: 11,
          placeholder: 'Seçiniz',
        },
      },
    };
  },
  computed: {},
};
</script>
